import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

import useClassy from '@core/hooks/useClassy';
import useUniqueId from '@core/hooks/useUniqueId';

import Modal, { ModalBody } from '@ui/Modal';
import Spinner from '@ui/Spinner';

import { useRedirectPendingModalContext } from './Context';
import styles from './index.module.scss';

export default function RedirectPendingModal() {
  const bem = useClassy(styles, 'RedirectPendingModal');
  const uid = useUniqueId('RedirectPendingModal');
  const modalContainerId = uid('modal');

  const modalRef = useRef<Modal>(null);
  const { redirectPendingModalValue } = useRedirectPendingModalContext();

  useEffect(() => {
    modalRef.current?.toggle(!!redirectPendingModalValue);
  }, [redirectPendingModalValue]);

  return (
    <>
      <Modal
        ref={modalRef}
        className={bem('-container')}
        noDismiss
        size="sm"
        target={`#${modalContainerId}`}
        verticalCenter
      >
        <ModalBody className={bem('-body')}>
          <Spinner size="md" />
          Redirecting…
        </ModalBody>
      </Modal>

      {createPortal(
        <div className={bem('&', 'ModalWrapper')} data-color-mode="dark" data-testid={bem()} id={modalContainerId} />,
        document.body,
      )}
    </>
  );
}

export * from './Context';
